import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Badge } from 'antd';

import './style.css';

const MobileCell = ({ date, bookings }) => {
  const listData = bookings.filter((doc) => {
    const { dateStart } = doc.data();
    return moment(dateStart).isSame(date, 'day');
  });

  if (listData.length > 0) {
    return <Badge status="success" />;
  }
  return null;
};

MobileCell.propTypes = {
  date: PropTypes.shape({
    getDay: PropTypes.func,
  }).isRequired,
  bookings: PropTypes.arrayOf(
    PropTypes.shape({
      startDate: PropTypes.string,
      rate: PropTypes.number,
    })
  ).isRequired,
};

MobileCell.defaultProps = {};

export default MobileCell;
